export default "__VITE_ASSET__282b03ab__"